import $ from 'jquery';
/**
 * Initialize Form UI for each expert booking form
 * Handles form submission and success message display
 */
export function initFormUI(expertId) {
    const formWrapper = $(`#form-wrapper-${expertId}`);
    if (!formWrapper.length)
        return;
    const properContainer = formWrapper.find('.proper-form-wrapper').length
        ? formWrapper.find('.proper-form-wrapper')
        : formWrapper;
    const backBtn = $(`#back-btn-form-${expertId}`);
    const successContent = $(`#success-message-${expertId}`);
    let submitting = false;
    const startSubmittingUI = () => {
        formWrapper.css('display', 'block');
        properContainer.css('display', 'block');
        if (backBtn.length)
            backBtn.hide();
        submitting = true;
    };
    const showSuccessUI = () => {
        formWrapper.css('display', 'block');
        properContainer.css('display', 'block');
        if (successContent.length) {
            successContent.css('display', 'flex');
            setupAddToCalendar(expertId);
        }
        submitting = false;
    };
    const properForm = properContainer.find('.mf_form__form');
    if (properForm.length && !properForm.data('bound-slider')) {
        properForm.one('submit', () => {
            startSubmittingUI();
        });
        properForm.data('bound-slider', 'true');
    }
    if (!properContainer[0]._sliderObserver) {
        const observer = new MutationObserver(() => {
            const formHidden = properContainer.find('.mf_form__form[style*="display: none"], .mf_form__form.hidden, .mf_form__form.is-hidden').length > 0;
            const formGone = properContainer.find('.mf_form__form').length === 0;
            if (formHidden || formGone)
                startSubmittingUI();
            let successEl = properContainer.find('.mf_form__success');
            if (!successEl.length)
                successEl = formWrapper.find('.mf_form__success');
            if (successEl.length) {
                const isVisibleInline = successEl.css('display') !== 'none';
                const isVisibleComputed = successEl.is(':visible');
                const isActuallyVisible = isVisibleInline || isVisibleComputed;
                if (isActuallyVisible) {
                    successEl.css('display', 'none');
                    if (submitting) {
                        showSuccessUI();
                    }
                }
            }
        });
        observer.observe(properContainer[0], {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
        });
        properContainer[0]._sliderObserver = observer;
    }
}
/**
 * Setup Add to Calendar button with ICS download
 */
function setupAddToCalendar(expertId) {
    const btn = $(`#add-to-calendar-${expertId}`);
    if (!btn.length || btn.data('bound-slider'))
        return;
    btn.on('click', function () {
        const formWrapper = $(`#form-wrapper-${expertId}`);
        const formEl = formWrapper.find('form')[0];
        const startISO = formEl ? formEl.getAttribute('data-start-time') : null;
        const endISO = formEl ? formEl.getAttribute('data-end-time') : null;
        let dtStart = startISO ? new Date(startISO) : null;
        let dtEnd = endISO ? new Date(endISO) : null;
        if (!dtStart || !dtEnd) {
            const slide = $(`.slide:has(.expert-booking-content[data-expert-id="${expertId}"])`);
            const selectedDate = slide.find('.selected-date').text().trim();
            const selectedTime = slide.find('.selected-time').text().trim();
            const expertName = slide.find('.box-title h3').text().trim();
            const duration = 30; // default duration
            if (selectedDate && selectedTime) {
                const dateParts = selectedDate.match(/(\w+)\s+(\d+),\s+(\d+)/);
                if (dateParts) {
                    const months = {
                        'January': 0, 'February': 1, 'March': 2, 'April': 3, 'May': 4, 'June': 5,
                        'July': 6, 'August': 7, 'September': 8, 'October': 9, 'November': 10, 'December': 11
                    };
                    const [, month, day, year] = dateParts;
                    const [hours, minutes] = selectedTime.split(':').map(Number);
                    dtStart = new Date(Date.UTC(year, months[month], day, hours || 0, minutes || 0, 0));
                    dtEnd = new Date(dtStart.getTime() + duration * 60000);
                }
            }
        }
        if (!dtStart || !dtEnd)
            return;
        const pad = (n) => String(n).padStart(2, '0');
        const toICSDate = (d) => `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`;
        const expertName = $(`.slide:has(.expert-booking-content[data-expert-id="${expertId}"]) .box-title h3`).text().trim() || 'Expert';
        const title = `Meeting with ${expertName}`;
        const description = `Teams meeting with ${expertName}`;
        const uid = `cg-booking-${expertId}-${Date.now()}@sogeti`;
        const ics = [
            'BEGIN:VCALENDAR',
            'VERSION:2.0',
            'PRODID:-//Sogeti//Book A Call//EN',
            'CALSCALE:GREGORIAN',
            'METHOD:PUBLISH',
            'BEGIN:VEVENT',
            `UID:${uid}`,
            `DTSTAMP:${toICSDate(new Date())}`,
            `DTSTART:${toICSDate(dtStart)}`,
            `DTEND:${toICSDate(dtEnd)}`,
            `SUMMARY:${title}`,
            `DESCRIPTION:${description}`,
            'END:VEVENT',
            'END:VCALENDAR'
        ].join('\r\n');
        const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `meeting-${expertId}.ics`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    });
    btn.data('bound-slider', 'true');
}
/**
 * Initialize all expert booking forms on the page
 */
export function initAllBookingForms() {
    $('.expert-booking-content').each(function () {
        const expertId = $(this).data('expert-id');
        if (expertId) {
            initFormUI(expertId);
        }
    });
}
